import { useListOrder } from '../../filter';
import { FileOrderKey } from '../domain';

export const useFileListOrder = () => {
  return useListOrder(FileOrderKey, 'fileOrderBy');
};
